import {
  GET_ME,
  LOADING_UPDATE_USER_PASS,
  SET_USER_PROFILE_IMGAE,
  LOADING_UPDATE_USER,
  SET_CURRENT_USER,
  SET_AUTH_TOKEN,
  SET_SHOW_OTP,
  SET_USER_SCORE,
  SET_LOADING_LOGOUT,
  SET_RESETPASS_NATIONALCODE,
  SET_SHOW_NATIONALCODE_DIALOG,
  SET_NATIONAL_CODE_OTP,
  SET_USER_LEVEL,
  SET_MAX_SCORE,
  SET_MIN_SCORE,
  SOUND_MUTED,
  SET_CHECK_USER_INFO,
  SHOW_REGISTER,
  REGISTER_CURRENT_STEP,
  LOADING_REGISTER,
  SUGGESTED_USER_DATA,
  SET_USER_POINT,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  checkUserInfo: null,
  showRegister: false,
  registerCurrStep: 0,
  loadingRegister: false,
  authToken: "",
  currentUser: null,
  loading_update_user_pass: false,
  userProfileImage: "",
  loadingUpdateUser: false,
  showOtp: false,
  userScore: 0,
  loadingLogOut: false,
  resetPassNationalCode: "",
  showNationalCodeDialog: true,
  nationalCodeOtp: "",
  userLevel: null,
  maxScore: 99,
  minScore: 0,
  suggestedUserData: null,
  soundMuted: localStorage.getItem("soudMuted")
    ? JSON.parse(localStorage.getItem("soudMuted"))
    : true,
  userPoint: 0,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CHECK_USER_INFO: {
      return { ...state, checkUserInfo: action.payload };
    }
    case LOADING_REGISTER: {
      return { ...state, loadingRegister: action.payload };
    }
    case SHOW_REGISTER: {
      return { ...state, showRegister: action.payload };
    }
    case REGISTER_CURRENT_STEP: {
      return { ...state, registerCurrStep: action.payload };
    }
    case GET_ME: {
      return { ...state, currentUser: action.payload };
    }
    case SET_AUTH_TOKEN: {
      return { ...state, authToken: action.payload };
    }
    case SET_CURRENT_USER: {
      return { ...state, currentUser: action.payload };
    }
    case LOADING_UPDATE_USER_PASS: {
      return { ...state, loading_update_user_pass: action.payload };
    }
    case SET_USER_PROFILE_IMGAE: {
      return { ...state, userProfileImage: action.payload };
    }
    case LOADING_UPDATE_USER: {
      return { ...state, loadingUpdateUser: action.payload };
    }
    case SET_SHOW_OTP: {
      return { ...state, showOtp: action.payload };
    }
    case SET_USER_SCORE: {
      return { ...state, userScore: action.payload };
    }
    case SET_LOADING_LOGOUT: {
      return { ...state, loadingLogOut: action.payload };
    }
    case SET_RESETPASS_NATIONALCODE: {
      return { ...state, resetPassNationalCode: action.payload };
    }
    case SET_SHOW_NATIONALCODE_DIALOG: {
      return { ...state, showNationalCodeDialog: action.payload };
    }
    case SET_NATIONAL_CODE_OTP: {
      return { ...state, nationalCodeOtp: action.payload };
    }
    case SET_USER_LEVEL: {
      return { ...state, userLevel: action.payload };
    }
    case SET_MAX_SCORE: {
      return { ...state, maxScore: action.payload };
    }
    case SET_MIN_SCORE: {
      return { ...state, minScore: action.payload };
    }
    case SUGGESTED_USER_DATA: {
      return { ...state, suggestedUserData: action.payload };
    }
    case SOUND_MUTED: {
      localStorage.setItem("soudMuted", JSON.stringify(action.payload));
      return { ...state, soundMuted: action.payload };
    }
    case SET_USER_POINT: {
      return { ...state, userPoint: action.payload };
    }
    default:
      return state;
  }
};
